import React, {Component} from "react";  import config from 'react-global-configuration';
import axios from "axios";
import $ from "jquery";
import Select from 'react-select';
import jwt_decode from "jwt-decode";
import {style} from "variables/Variables.jsx";
import { Link } from "react-router-dom";
import '../../assets/css/react-confirm-alert/react-confirm-alert.css';
import NotificationSystem from "react-notification-system";
import {confirmAlert} from 'react-confirm-alert';
import {BeatLoader} from 'react-spinners';
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import {css} from "@emotion/core";
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import * as moment from "moment";
import DatePicker from "react-datepicker";
import DownloadAllReport from '../DownloadReport/DownloadAllReport.jsx';
import "./campaign_module.css";
import { date_range_config,user_activities } from '../../helpers/utils.js';
import CampaignProductFilter from '../../filters/CampaignProductFilter.jsx';
import ChannelTypeFilter from '../../filters/ChannelTypeFilter.jsx';
import DateRangeFilter from '../../filters/DateRangeFilter.jsx';
import ChannelFilter from '../../filters/ChannelFilter.jsx';

const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align:center;
`;
var date_config = date_range_config('15', '0', '2020-02-01','0');
const d = new Date();
var year = d.getFullYear();
var month = d.getMonth();
var day = d.getDate();
class CampaignLists extends Component{
    constructor(props) {
        super(props);
        this.state = {
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            dateFromLimit: date_config.start_date_limit,
            dateLimit:date_config.end_date_limit,
            channel:"",
            channel_type:"",
            products:"",
            start_date: '',
            end_date: ''
        };

    }

    componentDidMount() {
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        this.setState({email:decoded.email});
        this.get_all_campaign();

    }

    get_all_campaign() {
        var postData = {
            products: this.state.products,
            channel_type: this.state.channel_type,
            yestSend: this.state.yestSend,
            todSend: this.state.todSend,
            channel: this.state.channel,
            start_date: this.state.start_date,
            end_date: this.state.end_date
        }
        if ($.fn.DataTable.isDataTable('#campaignTable')) {
            $('#campaignTable').DataTable().clear().destroy();
        }
        var campaignTable = $('#campaignTable').DataTable(
            {
                order:[],
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 10,
                "bInfo" : false,
                "autoWidth": false,
                "responsive": true,
                //"dom": '<"top"lf>t<"bottom"pi><"clear">',
                "searching": true,
                //"lengthMenu": [[20, 45, 50, -1], [20, 45, 50, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/CampaignModule/get_all_campaign",
                    type: "POST",
                    data: postData,
                    dataSrc:function ( json ) {
                        console.log(json)
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                },

                columns: [
                    {"data":"Product Name"},
                    {"data":"Channel Type"},
                    {"data":"Channel"},
                    {"data":"Start Date"},
                    {"data":"End Date"},
                    {"data":"UTM Code"},
                    {"data":"Campaign Name"},
                    {"data":"Campaign Name"}

                ],
                "columnDefs": [
                    {

                        "className":"text-center",
                        "targets": 7,
                        "data": "data",
                        "createdCell": (td, cellData, rowData, row, col) => {
                            $(td).text('');
                                $(td).append('<a href="#" data-tip="Stop" title="View" id="edit" class="btn btn-default actionBtn btn-edit"><span class="glyphicon glyphicon-edit" aria-hidden="true"></span></a>&nbsp;');
                                $(td).append('<a href="#" data-tip="Stop" title="View" id="View" class="btn btn-default actionBtn btn-edit"><span class="glyphicon glyphicon-eye-open" aria-hidden="true"></span></a>&nbsp;');
                                $(td).append('<a href="#" data-tip="Download" title="Download" id="Download" class="btn btn-default actionBtn btn-edit"><span class="glyphicon glyphicon-download-alt" aria-hidden="true"></span></a>&nbsp;');
                                $(td).find('#edit').click(e => {
                                    e.preventDefault(); // Prevent default link behavior
                                    this.redirect_to_campaign_edit(e, rowData.id);
                                });
                                $(td).find('#View').click(e => {
                                    e.preventDefault(); // Prevent default link behavior
                                    this.redirect_to_campaign_view(e, rowData.id);
                                });
                                $(td).find('#Download').click(e => {
                                    e.preventDefault(); // Prevent default link behavior
                                    this.downloadQR(e, rowData.qr_file_path_s3);
                                });
                        },
                        bSortable: false,
                    },
                    ]

            });
    }
    downloadQR(e, url) {

        const urlObject = new URL(url);
        const pathSegments = urlObject.pathname.split('/');
        var fileName = pathSegments[pathSegments.length - 1];

        var data = {
            fileName:fileName,
            keyName:"ccms_UTMQR"
        }
        axios.post(config.get('API_URL') + '/CampaignModule/download_s3_file', data, {
            responseType: 'blob',
            headers: {
              Authorization: ` ${localStorage.usertoken}`
            },
          }).then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName); // Set the download attribute with the file name
            document.body.appendChild(link);
            link.click();
            link.remove(); // Remove the link from the DOM
          }).catch(error => {
            console.error('Error downloading the file:', error);
          });
    }
    redirect_to_campaign_details(e,id) {
        const { history } = this.props;
        history.push('/admin/campaign-details/'+id);
    }
    redirect_to_campaign_edit(e,id) {
        const { history } = this.props;
        history.push('/admin/edit-campaign/'+id);
    }
    redirect_to_campaign_view(e,id) {
        const { history } = this.props;
        history.push('/admin/view-campaign/'+id);
    }
    handleCampaignProduct = (optionSelected, products) =>
    {
        this.setState({
            products:products,
            isChange: true
        });
    }
    handleChannelType = (optionSelected, channel_type) =>
    {
        this.setState({
            channel_type:channel_type,
            isChange: true
        });
        this.refs.ChannelFilter.get_channel(channel_type);
    }
    handleChannel = (optionSelected, channel) =>
    {
        this.setState({
            channel:channel,
            isChange: true
        });
    }
    handleFromChange = date => {

        var date_filter = moment(date).format('YYYY-MM-DD');
        this.setState({
            start_date: date_filter
        });
    };

    handleToChange = date => {
        var date_filter = moment(date).format('YYYY-MM-DD');
        this.setState({
            end_date: date_filter
        });
    };
    handleDateRange = (todSend, yestSend, datefromShow,dateToShow) =>
    {
        this.setState({
            todSend: todSend,
            yestSend: yestSend,
            datefromShow: datefromShow,
            dateToShow: dateToShow,
            isChange: true,
        });

    }
    downLoadCampaign(e){
        let filters = {
            start_date:this.state.yestSend,
            end_date:this.state.todSend,
            campaign_start_date:this.state.start_date,
            campaign_end_date:this.state.end_date,
            product_code:this.state.products,
            channel_type_code:this.state.channel_type,
            channel_code:this.state.channel,
            download: 1
        }
        this.setState({
            filters:filters
        })
        this.refs.downloadAllReport.downLoadReport(filters, '/marketing_campaign/get_all_campaign','campaign_report');
    }
    handleFromChangeRaw = (e) => {
        const inputValue = e.target.value;
        if (!moment(inputValue, "YYYY-MM-DD", true).isValid()) {
            console.log("invalid")
            this.setState({
                start_date: ""
            });
        } else {
            console.log("valid")
            this.setState({
                start_date: inputValue
            });
        }
    };
    render() {
        console.log("sfsf",this.state.start_date)
        return(
            <div className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 pt-5">
                            <div className="card">
                                <NotificationSystem ref="notificationSystem" style={style}/>
                                <div className="content">
                                    <div className="row">
                                        <NotificationSystem ref="notificationSystem" style={style} />
                                        <div className="col-md-12">
                                            <div className="col-md-3 ">
                                                <label> Product </label>
                                                <CampaignProductFilter ref="CampaignProductFilter" onSelectCampaignProduct = {this.handleCampaignProduct}/>

                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-3 ">
                                                <label> Channel Type(From) </label>
                                                <ChannelTypeFilter ref="ChannelTypeFilter" onSelectChannelType = {this.handleChannelType}/>

                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-3 ">
                                                <label> Channel</label>
                                                <ChannelFilter ref="ChannelFilter" onSelectChannel = {this.handleChannel} channel_type = {this.state.channel_type}/>
                                                <div className="clearfix"></div>
                                            </div>

                                            <div className="col-md-3 ">
                                                <label> Created date </label>
                                                    <DateRangeFilter ref="daterangeFilter" onSelectDate = {this.handleDateRange} start_date = {this.state.datefrom} end_date={this.state.dateTo} display_start_date = {this.state.datefromShow} display_end_date = {this.state.dateToShow}
                                                start_date_limit = {this.state.dateFromLimit} end_date_limit = {this.state.dateLimit}/>
                                                <div className="clearfix"></div>
                                            </div>
                                            </div>
                                            <div className="col-md-12">
                                            <div className="col-md-3 ">
                                                <label> Start Date </label>
                                                    <DatePicker
                                                        dateFormat="yyyy-MM-dd"
                                                        selected={Date.parse(this.state.start_date)}
                                                        onChange={this.handleFromChange}
//                                                         onChangeRaw={this.handleFromChangeRaw}
                                                    />
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-3 ">
                                                <label> End Date </label>
                                                    <DatePicker
                                                        dateFormat="yyyy-MM-dd"
                                                        selected={Date.parse(this.state.end_date)}
                                                        onChange={this.handleToChange}
                                                    />
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-5">
<label> &nbsp; </label>
                                        <button type="button" className="primary apply-filter-campaign" role="button"  onClick={this.get_all_campaign.bind(this)}>Apply</button>

                                    </div>

                                        </div>
                                    </div>
                                </div>
                                <hr className="m-0 p-0"/>
                                <div className="content table-full-width table-responsive nomargin">
                                    <div className="">
                                        <div className="col-md-8">
                                            <div className="header">
                                                <h4 className="title">All Campaign Lists</h4>
                                            </div>
                                        </div>
                                        <div className="col-md-4 text-right">
                                            <Link className="" to="/admin/create-new-campaign/">
                                                <button className="campaignButton" role="button"><span
                                                className="glyphicon glyphicon-plus" aria-hidden="true"></span>Add New Campaign</button>
                                             </Link>
                                        </div>
                                    </div>
                                    <div className="clearfix"></div>
                                    <div className="">
                                        <a href="#" className="exportButton" role="button" onClick={this.downLoadCampaign.bind(this)}>
                                            <i className="fa fa-download" aria-hidden="true"></i>
                                             Export to CSV
                                        </a>
                                    </div>
                                    <div className="clearfix"></div>
                                    <table id="campaignTable" className="table table-striped table-hover">
                                        <thead>
                                        <tr>
                                            <th>Product</th>
                                            <th>Channel Type (Form)</th>
                                            <th>Channel</th>
                                            <th>Start Date</th>
                                            <th>End Date</th>
                                            <th>UTM</th>
                                            <th>Campaign Name</th>
{/*                                             <th>Issues</th> */}
                                            <th>Action</th>
                                           
                                        </tr>
                                        </thead>
                                    </table>
                                </div>
                                <DownloadAllReport ref="downloadAllReport" />
                                <div className="footer">
                                    <div className="stats"><i></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            </div>
        );
    }
}

export default CampaignLists